import {Component, OnInit} from '@angular/core';
import {ParentService} from "../../services/mygreencountry/parent.service";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudentBonusesApiResponse} from "../../types/apiResponse.interface";
import {Observable} from "rxjs";
import {TranslocoService} from "@jsverse/transloco";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-loyalty-program',
    templateUrl: './loyalty-program.page.html',
    styleUrls: ['./loyalty-program.page.scss'],
})
export class LoyaltyProgramPage implements OnInit {
    title$: Observable<string>;
    activeChild$ = this.parentService.getActiveChild();

    public childId: number | undefined = undefined;

    public balanceInfo: StudentBonusesApiResponse | null = null;
    public showBalanceHistory: boolean = false;

    constructor(
        private parentService: ParentService,
        private preloaderService: PreloaderService,
        private translocoService: TranslocoService,
        private titleService: Title,
    ) {
        this.title$ = this.translocoService.selectTranslate('route.loyalty');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }

    ngOnInit() {
        // this.activeChild$.subscribe({
        //     next: (child) => {
        //
        //         if (child) {
        //
        //             this.childId = child.id;
        //
        //             this.loadBonuses(child.id);
        //         }
        //
        //     }
        // })
    }

    ionViewDidEnter() {
        let child = this.activeChild$.getValue();

        if (child) {

            this.childId = child.id;

            this.loadBonuses(child.id);
        }
    }

    refresh(event: any) {
        if (this.childId) {
            this.loadBonuses(this.childId, event);
        }
    }


    async loadBonuses(id: number, event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.parentService.getStudentBonuses(id)
            .subscribe({

                next: (response) => {

                    this.balanceInfo = response;
                    this.showBalanceHistory = this.balanceInfo.awards.length > 0;

                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();

                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }
}
